import type { PalProfileResponse } from '../cloud/api';
import { AccessoryId } from '../pal/face';
import { PalForm } from '../pal/types';

export interface FaceBaseProps {
    form: PalForm;
    marks: number;
    accessory: AccessoryId;
}

export function palFormFromString(s: string): PalForm {
    switch (s) {
        case 'baby':
            return PalForm.Baby;
        case 'calm_explorer':
            return PalForm.CalmExplorer;
        case 'night_cruiser':
            return PalForm.NightCruiser;
        case 'spirit_driver':
            return PalForm.SpiritDriver;
        default:
            console.warn(`palFormFromString: unknown form '${s}', falling back to Baby`);
            return PalForm.Baby;
    }
}

export function palProfileToFaceProps(pal: PalProfileResponse): FaceBaseProps {
    return {
        form: palFormFromString(pal.profile.active_form),
        marks: 0,
        accessory: AccessoryId.None,
    };
}
